import * as addressUserService from '../services/addressUser'

export const ACTIONS = {
  GET_ADDRESS_USER_REQUEST: 'GET_ADDRESS_USER_REQUEST',
  GET_ADDRESS_USER_SUCCESS: 'GET_ADDRESS_USER_SUCCESS',
  GET_ADDRESS_USER_FAILURE: 'GET_ADDRESS_USER_FAILURE',
  POST_ADDRESS_USER_REQUEST: 'POST_ADDRESS_USER_REQUEST',
  POST_ADDRESS_USER_SUCCESS: 'POST_ADDRESS_USER_SUCCESS',
  POST_ADDRESS_USER_FAILURE: 'POST_ADDRESS_USER_FAILURE',
  PUT_ADDRESS_USER_REQUEST: 'PUT_ADDRESS_USER_REQUEST',
  PUT_ADDRESS_USER_SUCCESS: 'PUT_ADDRESS_USER_SUCCESS',
  PUT_ADDRESS_USER_FAILURE: 'PUT_ADDRESS_USER_FAILURE',
  PATCH_ADDRESS_USER_REQUEST: 'PATCH_ADDRESS_USER_REQUEST',
  PATCH_ADDRESS_USER_SUCCESS: 'PATCH_ADDRESS_USER_SUCCESS',
  PATCH_ADDRESS_USER_FAILURE: 'PATCH_ADDRESS_USER_FAILURE',
}

export const GET_ADDRESS_USER_REQUEST = () => ({
  type: ACTIONS.GET_ADDRESS_USER_REQUEST,
})

export const GET_ADDRESS_USER_SUCCESS = (address) => ({
  type: ACTIONS.GET_ADDRESS_USER_SUCCESS,
  address,
})

export const GET_ADDRESS_USER_FAILURE = (err) => ({
  type: ACTIONS.GET_ADDRESS_USER_FAILURE,
  err,
})

export function getAddress() {
  return (dispatch) => {
    dispatch(GET_ADDRESS_USER_REQUEST())

    return addressUserService.getAddress().then(
      (response) => dispatch(GET_ADDRESS_USER_SUCCESS(response)),
      (err) => dispatch(GET_ADDRESS_USER_FAILURE(err))
    )
  }
}

export const POST_ADDRESS_USER_REQUEST = () => ({
  type: ACTIONS.POST_ADDRESS_USER_REQUEST,
})

export const POST_ADDRESS_USER_SUCCESS = (address) => ({
  type: ACTIONS.POST_ADDRESS_USER_SUCCESS,
  address,
})

export const POST_ADDRESS_USER_FAILURE = (err) => ({
  type: ACTIONS.POST_ADDRESS_USER_FAILURE,
  err,
})

export function postAddress(data) {
  return (dispatch) => {
    dispatch(POST_ADDRESS_USER_REQUEST())

    return addressUserService.postAddress(data).then(
      (response) => dispatch(POST_ADDRESS_USER_SUCCESS(response)),
      (err) => dispatch(POST_ADDRESS_USER_FAILURE(err))
    )
  }
}

export const PUT_ADDRESS_USER_REQUEST = () => ({
  type: ACTIONS.PUT_ADDRESS_USER_REQUEST,
})

export const PUT_ADDRESS_USER_SUCCESS = (address) => ({
  type: ACTIONS.PUT_ADDRESS_USER_SUCCESS,
  address,
})

export const PUT_ADDRESS_USER_FAILURE = (err) => ({
  type: ACTIONS.PUT_ADDRESS_USER_FAILURE,
  err,
})

export function putAddress(data, id) {
  return (dispatch) => {
    dispatch(PUT_ADDRESS_USER_REQUEST())

    return addressUserService.putAddress(data, id).then(
      (response) => dispatch(PUT_ADDRESS_USER_SUCCESS(response)),
      (err) => dispatch(PUT_ADDRESS_USER_FAILURE(err))
    )
  }
}

export const PATCH_ADDRESS_USER_REQUEST = () => ({
  type: ACTIONS.PATCH_ADDRESS_USER_REQUEST,
})

export const PATCH_ADDRESS_USER_SUCCESS = (address) => ({
  type: ACTIONS.PATCH_ADDRESS_USER_SUCCESS,
  address,
})

export const PATCH_ADDRESS_USER_FAILURE = (err) => ({
  type: ACTIONS.PATCH_ADDRESS_USER_FAILURE,
  err,
})

export function patchAddress(id) {
  return (dispatch) => {
    dispatch(PATCH_ADDRESS_USER_REQUEST())

    return addressUserService.patchAddress(id).then(
      (response) => dispatch(PATCH_ADDRESS_USER_SUCCESS(response)),
      (err) => dispatch(PATCH_ADDRESS_USER_FAILURE(err))
    )
  }
}
